export default __webpack_public_path__ + "static/media/AP-Temple-preloader.3602fe40.gif";